import { createSlice } from "@reduxjs/toolkit";
import { getTodayString } from "../../../utils/helpers";

const initialState = {
  appointments: [],
  queueStats: {
    totalToday: 0,
    scheduledCount: 0,
    waitingCount: 0,
    inConsultationCount: 0,
    completedToday: 0,
    cancelledCount: 0,
    totalRevenue: 0,
  },
  doctorSchedule: null,
  patientSearchResults: [],
  selectedDate: getTodayString(),
  activeTab: "queue", // 'queue' | 'calendar' | 'table' | 'receipts' | 'settings'
  loading: false,
  error: null,
};

const appointmentSlice = createSlice({
  name: "appointment",
  initialState,
  reducers: {
    setAppointments: (state, action) => {
      state.appointments = action.payload;
    },
    setQueueStats: (state, action) => {
      state.queueStats = action.payload;
    },
    setDoctorSchedule: (state, action) => {
      state.doctorSchedule = action.payload;
    },
    setPatientSearchResults: (state, action) => {
      state.patientSearchResults = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setAppointmentLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAppointmentError: (state, action) => {
      state.error = action.payload;
    },
    updateSingleAppointmentInState: (state, action) => {
      const updated = action.payload;
      const index = state.appointments.findIndex((a) => a.AID === updated.AID);
      if (index !== -1) {
        state.appointments[index] = updated;
      }
    },
  },
});

export const {
  setAppointments,
  setQueueStats,
  setDoctorSchedule,
  setPatientSearchResults,
  setSelectedDate,
  setActiveTab,
  setAppointmentLoading,
  setAppointmentError,
  updateSingleAppointmentInState,
} = appointmentSlice.actions;

export default appointmentSlice.reducer;
